import React from "react";
import { Modal } from "antd";
import closeFillIcon from "../../../../assets/images/product/specmanager/close-fill.svg";
import successIcon from "../../../../assets/images/product/specmanager/Success.svg";
import informationIcon from "../../../../assets/images/product/specmanager/information-line.svg";
import "./SaveSuccessModal.css";

export default function SaveSuccessModal({
  open,
  testDisplayName,
  saveAction,
  affectedProductCount,
  onClose,
}) {
  return (
    <Modal
      open={open}
      centered
      closable={false}
      maskClosable={false}
      footer={null}
      width={520}
      wrapClassName="TestSpecSaveSuccessModal_Wrap"
      onCancel={onClose}
    >
      <div className="TestSpecSaveSuccessModal">
        <button
          type="button"
          className="TestSpecSaveSuccessModal_Close"
          aria-label="Close"
          onClick={onClose}
        >
          <img src={closeFillIcon} alt="" className="TestSpecSaveSuccessModal_CloseIcon" aria-hidden />
        </button>

        <div className="TestSpecSaveSuccessModal_Column">
          <div className="TestSpecSaveSuccessModal_CheckmarkBackground">
            <img src={successIcon} alt="" className="TestSpecSaveSuccessModal_SuccessIcon" aria-hidden />
          </div>
          <div className="TestSpecSaveSuccessModal_TextStack">
            <h2 className="TestSpecSaveSuccessModal_Title">{saveAction === "add" ? "Spec Added Successfully" : "Spec Updated Successfully"}</h2>
            <p className="TestSpecSaveSuccessModal_Sub">
              {saveAction === "add" ? "The new spec for" : "The updated spec for"}
              {" "}
              <span className="TestSpecSaveSuccessModal_TestName">{testDisplayName}</span>
              {" "}
              has been applied to
              {" "}
              <span className="TestSpecSaveSuccessModal_ProductEmphasis">
                {affectedProductCount}
                {" "}
                {"product(s)"}
              </span>
              .
            </p>
          </div>
          <div className="TestSpecSaveSuccessModal_Banner">
            <img src={informationIcon} alt="" className="TestSpecSaveSuccessModal_BannerIcon" aria-hidden />
            <p className="TestSpecSaveSuccessModal_BannerText">
              Products with product-specific limits remain unchanged when applying to standard spec only.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
